export default __webpack_public_path__ + "static/media/facebook.c3a779e5.svg";